export const SCHEME_MAPPING = {
  1: "Per Drop More Crop(PDMC)",
  2: "Rainfed Area Development", 
  3: "Agroforestry",
  4: "Seed Hub",
  5: "National Mission on Edible Oils (NMEO)-OS",
  6: "National Mission on Natural Farming (NMNF)",
  7: "NBHM",
  8: "Mission for Integrated Development of Horticulture (MIDH)",
  9: "MOVCD",
  10: "Coconut Development Board (CDB)",
  11: "Directorate of Arecanut and Spices Development (DASD)",
  12: "Ground Truthing (GT)",
  13: "Crop Health",
  14: "National Mission on Edible Oils (NMEO)-OP",
  15: "RKVY DPR",
  17: "Directorate of Cashewnut and Cocoa Development (DCCD)",
  16: "CIH",
  18: "ACABC", 
  20: "ATMA",
  21: "National Bamboo Mission (NBM)",
  22: "PKVY",
  23: "PDMC-API",
  24: "Agri Infra Fund",
  27: "MT-SMAM",
  29: "Seed Hub",
  33: "Agriculture Marketing Infrastructure (AMI)",
  40: "MT-CRM",
  45:"ISAM FPOs",
  41:"(NFSM) BD",
  42:"(NFSM) CFLD",
  43: "(NFSM) FLD",
  53:"National Seed Reserve (NSR)",
  56: "Makhana Board (Beneficiary)",
  57:"Makhana Board (Asset)",
  58: "NMEO-OS (CFLD)",
  59: "NMEO-OS (FLD) ",
  60: "NMEO-OS (SD)",
  70: "MT-FMTTI Demonstration",
  71: "MT-CRM Machine Demonstration",
  73:"MT-ICAR Machine Demonstration",
  74:"MT-Individual Crm Survey",
  75:"MT-Individual SMAM Survey",
};

// ACABC sub-scheme mapping
export const ACABC_SUB_SCHEMES = {
  1: "ACABC (Agriventure)",
  2: "ACABC (Nodal Training Institute)"
};

// ATMA sub-scheme mapping
export const ATMA_SUB_SCHEMES = {
  1: "(ATMA) SD",
  2: "(ATMA) CFLD",
  3: "(ATMA) FLD"
};
export const NBHM_SUB_SCHEMES = {
  1: "NBHM - Honey Processing Unit",
  2: "NBHM - Honey Testing Unit",
  3: "NBHM - Honey CHC",
  4: "NBHM - Beeflora Plantation"
};
// Combined mapping for display purposes
export const COMBINED_SCHEME_MAPPING = {
  ...SCHEME_MAPPING,
  ...Object.fromEntries(
    Object.entries(ACABC_SUB_SCHEMES).map(([code, name]) => [
      `18-${code}`, // Combine scheme and sub-scheme codes
      name
    ])
  ),
  ...Object.fromEntries(
    Object.entries(ATMA_SUB_SCHEMES).map(([code, name]) => [
      `20-${code}`, // Combine scheme and sub-scheme codes
      name
    ])
  ),
  ...Object.fromEntries(
    Object.entries(NBHM_SUB_SCHEMES).map(([code, name]) => [
      `7-${code}`, // Combine scheme and sub-scheme codes
      name
       ])
  ),
};

// Simple reverse mapping for main schemes
export const SCHEME_NAME_TO_CODE = {};
Object.entries(SCHEME_MAPPING).forEach(([code, name]) => {
  SCHEME_NAME_TO_CODE[name] = parseInt(code);
});

// Function to get scheme code by name (supports ACABC and ATMA sub-schemes)
export const getSchemeCodeByName = (schemeName) => {
  if (!schemeName) return null;
  
  // Check if it's an ACABC sub-scheme
  for (const [code, name] of Object.entries(ACABC_SUB_SCHEMES)) {
    if (schemeName === name) {
      return {
        schemeCode: 18,
        subSchemeCode: parseInt(code)
      };
    }
  }
  
  // Check if it's an ATMA sub-scheme
 for (const [code, name] of Object.entries(ATMA_SUB_SCHEMES)) {
    if (schemeName === name) {
      return {
        schemeCode: 20,
        subSchemeCode: parseInt(code)
      };
    }
  }
  for (const [code, name] of Object.entries(NBHM_SUB_SCHEMES)) {
    if (schemeName === name) {
      return {
        schemeCode: 7,
        subSchemeCode: parseInt(code)
      };
    }
  }
  // Direct match for main schemes
  if (SCHEME_NAME_TO_CODE[schemeName]) {
    return SCHEME_NAME_TO_CODE[schemeName];
  }
  
  console.log('Scheme name not found in mapping:', schemeName);
  return null;
};

// Function to get scheme name by code (supports ACABC and ATMA sub-schemes)
export const getSchemeNameByCode = (schemeCode, subSchemeCode = null) => {
  const code = parseInt(schemeCode);
  
  // Handle ACABC sub-schemes
  if (code === 18 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return ACABC_SUB_SCHEMES[subCode] || SCHEME_MAPPING[code];
  }
  
  // Handle ATMA sub-schemes
  if (code === 20 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return ATMA_SUB_SCHEMES[subCode] || SCHEME_MAPPING[code];
  }
  // Handle NBHM sub-schemes
  if (code === 7 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return NBHM_SUB_SCHEMES[subCode] || SCHEME_MAPPING[code];
  }
  return SCHEME_MAPPING[code] || null;
};

// Function to get full scheme info including sub-scheme
export const getSchemeInfo = (schemeCode, subSchemeCode = null) => {
  const code = parseInt(schemeCode);
  
  // Handle ACABC sub-schemes
  if (code === 18 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return {
      schemeCode: code,
      schemeName: SCHEME_MAPPING[code],
      subSchemeCode: subCode,
      subSchemeName: ACABC_SUB_SCHEMES[subCode],
      displayName: ACABC_SUB_SCHEMES[subCode]
    };
  }
  
  // Handle ATMA sub-schemes
  if (code === 20 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return {
      schemeCode: code,
      schemeName: SCHEME_MAPPING[code],
      subSchemeCode: subCode,
      subSchemeName: ATMA_SUB_SCHEMES[subCode],
      displayName: ATMA_SUB_SCHEMES[subCode]
    };
  }
   if (code === 7 && subSchemeCode) {
    const subCode = parseInt(subSchemeCode);
    return {
      schemeCode: code,
      schemeName: SCHEME_MAPPING[code],
      subSchemeCode: subCode,
      subSchemeName: NBHM_SUB_SCHEMES[subCode],
      displayName: NBHM_SUB_SCHEMES[subCode]
    };
  }
  
  return {
    schemeCode: code,
    schemeName: SCHEME_MAPPING[code],
    displayName: SCHEME_MAPPING[code]
  };
};

// Function to check if scheme has sub-schemes
export const hasSubSchemes = (schemeCode) => {
  const code = parseInt(schemeCode);
  return code === 18 || code === 20 ||code === 7;
};

// Function to get all sub-schemes for a scheme
export const getSubSchemes = (schemeCode) => {
  const code = parseInt(schemeCode);
  
  if (code === 18) {
    return Object.entries(ACABC_SUB_SCHEMES).map(([code, name]) => ({
      subSchemeCode: parseInt(code),
      subSchemeName: name,
      fullName: name
    }));
  }
  
  if (code === 20) {
    return Object.entries(ATMA_SUB_SCHEMES).map(([code, name]) => ({
      subSchemeCode: parseInt(code),
      subSchemeName: name,
      fullName: name
    }));
  }
   if (code === 7) {
    return Object.entries(NBHM_SUB_SCHEMES).map(([code, name]) => ({
      subSchemeCode: parseInt(code),
      subSchemeName: name,
      fullName: name
    }));
  }
  
  return [];
};